var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDefaultCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52576 1.34326L10.2328 4.96409C10.3165 5.14608 10.4812 5.2733 10.6729 5.30398L14.4936 5.88664C14.6487 5.90895 14.7887 5.99478 14.8826 6.12505C14.9766 6.25531 15.0165 6.4192 14.9937 6.58029C14.9745 6.7127 14.9135 6.83472 14.8204 6.92711L12.0531 9.75719C11.9133 9.89666 11.8506 10.1002 11.8864 10.2982L12.5532 14.2867C12.6015 14.6153 12.3881 14.9237 12.0731 14.9803C11.9433 15.0015 11.8103 14.9797 11.6931 14.9179L8.28571 13.0381C8.1155 12.9406 7.90915 12.9406 7.73894 13.0381L4.31158 14.9318C4.02403 15.0853 3.67128 14.9712 3.51809 14.6751C3.45836 14.5558 3.43731 14.4195 3.45808 14.2867L4.12488 10.2982C4.15713 10.1004 4.09496 9.89864 3.95818 9.75719L1.17095 6.92711C0.943015 6.68672 0.943015 6.30044 1.17095 6.06005C1.26398 5.97045 1.37963 5.9103 1.50435 5.88664L5.32512 5.30398C5.51589 5.27106 5.67972 5.14453 5.76521 4.96409L7.47222 1.34326C7.53967 1.19644 7.66125 1.08418 7.80939 1.03194C7.95753 0.979706 8.11968 0.991913 8.25904 1.0658C8.37403 1.12646 8.46745 1.22364 8.52576 1.34326Z",
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefaultCalendar);
export default __webpack_public_path__ + "static/media/ic_default_calendar.eac9aea81d758ac28d33598312eba6e8.svg";
export { ForwardRef as ReactComponent };